function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { utils as utils_exports, DEFAULTS, registerButton, TypedEvent, AbstractButton, events as events_exports$1, AbstractConfigurablePlugin, PSVError, CONSTANTS as constants_exports } from '../core/index.module.js';
import { Vector3, MathUtils, PlaneGeometry, Mesh, Group, Texture, VideoTexture, ShaderMaterial, Vector2, Color } from '../../three/build/three.module.js';

/*!
 * PhotoSphereViewer.MarkersPlugin 5.6.0
 * @copyright 2024 Damien "Mistic" Sorel
 * @licence MIT (https://opensource.org/licenses/MIT)
 */
var __defProp = Object.defineProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};

// src/events.ts
var events_exports = {};
__export(events_exports, {
  EnterMarkerEvent: function EnterMarkerEvent() {
    return _EnterMarkerEvent2;
  },
  GotoMarkerDoneEvent: function GotoMarkerDoneEvent() {
    return _GotoMarkerDoneEvent2;
  },
  HideMarkersEvent: function HideMarkersEvent() {
    return _HideMarkersEvent2;
  },
  LeaveMarkerEvent: function LeaveMarkerEvent() {
    return _LeaveMarkerEvent2;
  },
  MarkerVisibilityEvent: function MarkerVisibilityEvent() {
    return _MarkerVisibilityEvent2;
  },
  MarkersPluginEvent: function MarkersPluginEvent() {
    return _MarkersPluginEvent;
  },
  RenderMarkersListEvent: function RenderMarkersListEvent() {
    return _RenderMarkersListEvent2;
  },
  SelectMarkerEvent: function SelectMarkerEvent() {
    return _SelectMarkerEvent2;
  },
  SelectMarkerListEvent: function SelectMarkerListEvent() {
    return _SelectMarkerListEvent2;
  },
  SetMarkersEvent: function SetMarkersEvent() {
    return _SetMarkersEvent2;
  },
  ShowMarkersEvent: function ShowMarkersEvent() {
    return _ShowMarkersEvent2;
  },
  UnselectMarkerEvent: function UnselectMarkerEvent() {
    return _UnselectMarkerEvent2;
  }
});
var _MarkersPluginEvent = /*#__PURE__*/function (_TypedEvent) {
  _inherits(_MarkersPluginEvent, _TypedEvent);
  var _super = _createSuper(_MarkersPluginEvent);
  function _MarkersPluginEvent() {
    _classCallCheck(this, _MarkersPluginEvent);
    return _super.apply(this, arguments);
  }
  return _createClass(_MarkersPluginEvent);
}(TypedEvent);
var _MarkerVisibilityEvent = /*#__PURE__*/function (_MarkersPluginEvent2) {
  _inherits(_MarkerVisibilityEvent, _MarkersPluginEvent2);
  var _super2 = _createSuper(_MarkerVisibilityEvent);
  /** @internal */
  function _MarkerVisibilityEvent(marker, visible) {
    var _this;
    _classCallCheck(this, _MarkerVisibilityEvent);
    _this = _super2.call(this, _MarkerVisibilityEvent.type);
    _this.marker = marker;
    _this.visible = visible;
    return _this;
  }
  return _createClass(_MarkerVisibilityEvent);
}(_MarkersPluginEvent);
_MarkerVisibilityEvent.type = "marker-visibility";
var _MarkerVisibilityEvent2 = _MarkerVisibilityEvent;
var _GotoMarkerDoneEvent = /*#__PURE__*/function (_MarkersPluginEvent3) {
  _inherits(_GotoMarkerDoneEvent, _MarkersPluginEvent3);
  var _super3 = _createSuper(_GotoMarkerDoneEvent);
  /** @internal */
  function _GotoMarkerDoneEvent(marker) {
    var _this2;
    _classCallCheck(this, _GotoMarkerDoneEvent);
    _this2 = _super3.call(this, _GotoMarkerDoneEvent.type);
    _this2.marker = marker;
    return _this2;
  }
  return _createClass(_GotoMarkerDoneEvent);
}(_MarkersPluginEvent);
_GotoMarkerDoneEvent.type = "goto-marker-done";
var _GotoMarkerDoneEvent2 = _GotoMarkerDoneEvent;
var _LeaveMarkerEvent = /*#__PURE__*/function (_MarkersPluginEvent4) {
  _inherits(_LeaveMarkerEvent, _MarkersPluginEvent4);
  var _super4 = _createSuper(_LeaveMarkerEvent);
  /** @internal */
  function _LeaveMarkerEvent(marker) {
    var _this3;
    _classCallCheck(this, _LeaveMarkerEvent);
    _this3 = _super4.call(this, _LeaveMarkerEvent.type);
    _this3.marker = marker;
    return _this3;
  }
  return _createClass(_LeaveMarkerEvent);
}(_MarkersPluginEvent);
_LeaveMarkerEvent.type = "leave-marker";
var _LeaveMarkerEvent2 = _LeaveMarkerEvent;
var _EnterMarkerEvent = /*#__PURE__*/function (_MarkersPluginEvent5) {
  _inherits(_EnterMarkerEvent, _MarkersPluginEvent5);
  var _super5 = _createSuper(_EnterMarkerEvent);
  /** @internal */
  function _EnterMarkerEvent(marker) {
    var _this4;
    _classCallCheck(this, _EnterMarkerEvent);
    _this4 = _super5.call(this, _EnterMarkerEvent.type);
    _this4.marker = marker;
    return _this4;
  }
  return _createClass(_EnterMarkerEvent);
}(_MarkersPluginEvent);
_EnterMarkerEvent.type = "enter-marker";
var _EnterMarkerEvent2 = _EnterMarkerEvent;
var _SelectMarkerEvent = /*#__PURE__*/function (_MarkersPluginEvent6) {
  _inherits(_SelectMarkerEvent, _MarkersPluginEvent6);
  var _super6 = _createSuper(_SelectMarkerEvent);
  /** @internal */
  function _SelectMarkerEvent(marker, doubleClick, rightClick) {
    var _this5;
    _classCallCheck(this, _SelectMarkerEvent);
    _this5 = _super6.call(this, _SelectMarkerEvent.type);
    _this5.marker = marker;
    _this5.doubleClick = doubleClick;
    _this5.rightClick = rightClick;
    return _this5;
  }
  return _createClass(_SelectMarkerEvent);
}(_MarkersPluginEvent);
_SelectMarkerEvent.type = "select-marker";
var _SelectMarkerEvent2 = _SelectMarkerEvent;
var _SelectMarkerListEvent = /*#__PURE__*/function (_MarkersPluginEvent7) {
  _inherits(_SelectMarkerListEvent, _MarkersPluginEvent7);
  var _super7 = _createSuper(_SelectMarkerListEvent);
  /** @internal */
  function _SelectMarkerListEvent(marker) {
    var _this6;
    _classCallCheck(this, _SelectMarkerListEvent);
    _this6 = _super7.call(this, _SelectMarkerListEvent.type);
    _this6.marker = marker;
    return _this6;
  }
  return _createClass(_SelectMarkerListEvent);
}(_MarkersPluginEvent);
_SelectMarkerListEvent.type = "select-marker-list";
var _SelectMarkerListEvent2 = _SelectMarkerListEvent;
var _UnselectMarkerEvent = /*#__PURE__*/function (_MarkersPluginEvent8) {
  _inherits(_UnselectMarkerEvent, _MarkersPluginEvent8);
  var _super8 = _createSuper(_UnselectMarkerEvent);
  /** @internal */
  function _UnselectMarkerEvent(marker) {
    var _this7;
    _classCallCheck(this, _UnselectMarkerEvent);
    _this7 = _super8.call(this, _UnselectMarkerEvent.type);
    _this7.marker = marker;
    return _this7;
  }
  return _createClass(_UnselectMarkerEvent);
}(_MarkersPluginEvent);
_UnselectMarkerEvent.type = "unselect-marker";
var _UnselectMarkerEvent2 = _UnselectMarkerEvent;
var _HideMarkersEvent = /*#__PURE__*/function (_MarkersPluginEvent9) {
  _inherits(_HideMarkersEvent, _MarkersPluginEvent9);
  var _super9 = _createSuper(_HideMarkersEvent);
  /** @internal */
  function _HideMarkersEvent() {
    _classCallCheck(this, _HideMarkersEvent);
    return _super9.call(this, _HideMarkersEvent.type);
  }
  return _createClass(_HideMarkersEvent);
}(_MarkersPluginEvent);
_HideMarkersEvent.type = "hide-markers";
var _HideMarkersEvent2 = _HideMarkersEvent;
var _SetMarkersEvent = /*#__PURE__*/function (_MarkersPluginEvent10) {
  _inherits(_SetMarkersEvent, _MarkersPluginEvent10);
  var _super10 = _createSuper(_SetMarkersEvent);
  /** @internal */
  function _SetMarkersEvent(markers) {
    var _this8;
    _classCallCheck(this, _SetMarkersEvent);
    _this8 = _super10.call(this, _SetMarkersEvent.type);
    _this8.markers = markers;
    return _this8;
  }
  return _createClass(_SetMarkersEvent);
}(_MarkersPluginEvent);
_SetMarkersEvent.type = "set-markers";
var _SetMarkersEvent2 = _SetMarkersEvent;
var _ShowMarkersEvent = /*#__PURE__*/function (_MarkersPluginEvent11) {
  _inherits(_ShowMarkersEvent, _MarkersPluginEvent11);
  var _super11 = _createSuper(_ShowMarkersEvent);
  /** @internal */
  function _ShowMarkersEvent() {
    _classCallCheck(this, _ShowMarkersEvent);
    return _super11.call(this, _ShowMarkersEvent.type);
  }
  return _createClass(_ShowMarkersEvent);
}(_MarkersPluginEvent);
_ShowMarkersEvent.type = "show-markers";
var _ShowMarkersEvent2 = _ShowMarkersEvent;
var _RenderMarkersListEvent = /*#__PURE__*/function (_MarkersPluginEvent12) {
  _inherits(_RenderMarkersListEvent, _MarkersPluginEvent12);
  var _super12 = _createSuper(_RenderMarkersListEvent);
  /** @internal */
  function _RenderMarkersListEvent(markers) {
    var _this9;
    _classCallCheck(this, _RenderMarkersListEvent);
    _this9 = _super12.call(this, _RenderMarkersListEvent.type);
    _this9.markers = markers;
    return _this9;
  }
  return _createClass(_RenderMarkersListEvent);
}(_MarkersPluginEvent);
_RenderMarkersListEvent.type = "render-markers-list";
var _RenderMarkersListEvent2 = _RenderMarkersListEvent;

// src/icons/pin.svg
var pin_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="10 9 81 81"><path fill="currentColor" d="M50.5 90S22.9 51.9 22.9 36.6 35.2 9 50.5 9s27.6 12.4 27.6 27.6S50.5 90 50.5 90zm0-66.3c-6.1 0-11 4.9-11 11s4.9 11 11 11 11-4.9 11-11-4.9-11-11-11z"/><!--Created by Rohith M S from the Noun Project--></svg>\n';

// src/MarkersButton.ts
var MarkersButton = /*#__PURE__*/function (_AbstractButton) {
  _inherits(MarkersButton, _AbstractButton);
  var _super13 = _createSuper(MarkersButton);
  function MarkersButton(navbar) {
    var _this10;
    _classCallCheck(this, MarkersButton);
    _this10 = _super13.call(this, navbar, {
      className: "psv-markers-button",
      icon: pin_default,
      hoverScale: true,
      collapsable: true,
      tabbable: true
    });
    _this10.plugin = _this10.viewer.getPlugin("markers");
    if (_this10.plugin) {
      _this10.plugin.addEventListener(_ShowMarkersEvent2.type, _assertThisInitialized(_this10));
      _this10.plugin.addEventListener(_HideMarkersEvent2.type, _assertThisInitialized(_this10));
      _this10.toggleActive(true);
    }
    return _this10;
  }
  _createClass(MarkersButton, [{
    key: "destroy",
    value: function destroy() {
      if (this.plugin) {
        this.plugin.removeEventListener(_ShowMarkersEvent2.type, this);
        this.plugin.removeEventListener(_HideMarkersEvent2.type, this);
      }
      _get(_getPrototypeOf(MarkersButton.prototype), "destroy", this).call(this);
    }
  }, {
    key: "isSupported",
    value: function isSupported() {
      return !!this.plugin;
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e instanceof _ShowMarkersEvent2) {
        this.toggleActive(true);
      } else if (e instanceof _HideMarkersEvent2) {
        this.toggleActive(false);
      }
    }
  }, {
    key: "onClick",
    value: function onClick() {
      this.plugin.toggleAllMarkers();
    }
  }]);
  return MarkersButton;
}(AbstractButton);
MarkersButton.id = "markers";

// src/icons/pin-list.svg
var pin_list_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="9 9 81 81"><path fill="currentColor" d="M37.5 90S9.9 51.9 9.9 36.6 22.2 9 37.5 9s27.6 12.4 27.6 27.6S37.5 90 37.5 90zm0-66.3c-6.1 0-11 4.9-11 11s4.9 11 11 11 11-4.9 11-11-4.9-11-11-11zM86.7 55H70c-1.8 0-3.3-1.5-3.3-3.3s1.5-3.3 3.3-3.3h16.7c1.8 0 3.3 1.5 3.3 3.3S88.5 55 86.7 55zm0-25h-15a3.3 3.3 0 0 1-3.3-3.3c0-1.8 1.5-3.3 3.3-3.3h15c1.8 0 3.3 1.5 3.3 3.3 0 1.8-1.5 3.3-3.3 3.3zM56.5 73h30c1.8 0 3.3 1.5 3.3 3.3 0 1.8-1.5 3.3-3.3 3.3h-30a3.3 3.3 0 0 1-3.3-3.3 3.2 3.2 0 0 1 3.3-3.3z"/><!--Created by Rohith M S from the Noun Project--></svg>\n';

// src/constants.ts
var SVG_NS = "http://www.w3.org/2000/svg";
var MARKER_DATA = "psvMarker";
var MARKER_DATA_KEY = utils_exports.dasherize(MARKER_DATA);
var ID_PANEL_MARKER = "marker";
var ID_PANEL_MARKERS_LIST = "markersList";
var DEFAULT_HOVER_SCALE = {
  amount: 2,
  duration: 100,
  easing: "linear"
};
var MARKERS_LIST_TEMPLATE = function MARKERS_LIST_TEMPLATE(markers, title) {
  return "\n<div class=\"psv-panel-menu psv-panel-menu--stripped\">\n <h1 class=\"psv-panel-menu-title\">".concat(pin_list_default, " ").concat(title, "</h1>\n <ul class=\"psv-panel-menu-list\">\n   ").concat(markers.map(function (marker) {
    return "\n   <li data-".concat(MARKER_DATA_KEY, "=\"").concat(marker.id, "\" class=\"psv-panel-menu-item\" tabindex=\"0\">\n     ").concat(marker.type === "image" ? "<span class=\"psv-panel-menu-item-icon\"><img src=\"".concat(marker.definition, "\"/></span>") : "", "\n     <span class=\"psv-panel-menu-item-label\">").concat(marker.getListContent(), "</span>\n   </li>\n   ");
  }).join(""), "\n </ul>\n</div>\n");
};

// src/MarkersListButton.ts
var MarkersListButton = /*#__PURE__*/function (_AbstractButton2) {
  _inherits(MarkersListButton, _AbstractButton2);
  var _super14 = _createSuper(MarkersListButton);
  function MarkersListButton(navbar) {
    var _this11;
    _classCallCheck(this, MarkersListButton);
    _this11 = _super14.call(this, navbar, {
      className: " psv-markers-list-button",
      icon: pin_list_default,
      hoverScale: true,
      collapsable: true,
      tabbable: true
    });
    _this11.plugin = _this11.viewer.getPlugin("markers");
    if (_this11.plugin) {
      _this11.viewer.addEventListener(events_exports$1.ShowPanelEvent.type, _assertThisInitialized(_this11));
      _this11.viewer.addEventListener(events_exports$1.HidePanelEvent.type, _assertThisInitialized(_this11));
    }
    return _this11;
  }
  _createClass(MarkersListButton, [{
    key: "destroy",
    value: function destroy() {
      this.viewer.removeEventListener(events_exports$1.ShowPanelEvent.type, this);
      this.viewer.removeEventListener(events_exports$1.HidePanelEvent.type, this);
      _get(_getPrototypeOf(MarkersListButton.prototype), "destroy", this).call(this);
    }
  }, {
    key: "isSupported",
    value: function isSupported() {
      return !!this.plugin;
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e instanceof events_exports$1.ShowPanelEvent) {
        this.toggleActive(e.panelId === ID_PANEL_MARKERS_LIST);
      } else if (e instanceof events_exports$1.HidePanelEvent) {
        this.toggleActive(false);
      }
    }
  }, {
    key: "onClick",
    value: function onClick() {
      this.plugin.toggleMarkersList();
    }
  }]);
  return MarkersListButton;
}(AbstractButton);
MarkersListButton.id = "markersList";
var MarkerType = /* @__PURE__ */function (MarkerType3) {
  MarkerType3["image"] = "image";
  MarkerType3["html"] = "html";
  MarkerType3["element"] = "element";
  MarkerType3["imageLayer"] = "imageLayer";
  MarkerType3["videoLayer"] = "videoLayer";
  MarkerType3["polygon"] = "polygon";
  MarkerType3["polygonPixels"] = "polygonPixels";
  MarkerType3["polyline"] = "polyline";
  MarkerType3["polylinePixels"] = "polylinePixels";
  MarkerType3["square"] = "square";
  MarkerType3["rect"] = "rect";
  MarkerType3["circle"] = "circle";
  MarkerType3["ellipse"] = "ellipse";
  MarkerType3["path"] = "path";
  return MarkerType3;
}(MarkerType || {});
function getMarkerType(config) {
  var allowNone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var found = [];
  Object.keys(MarkerType).forEach(function (type) {
    if (config[type]) {
      found.push(type);
    }
  });
  if (found.length === 0 && !allowNone) {
    throw new PSVError("missing marker content, either ".concat(Object.keys(MarkerType).join(", ")));
  } else if (found.length > 1) {
    throw new PSVError("multiple marker content, either ".concat(Object.keys(MarkerType).join(", ")));
  }
  return found[0];
}
var Marker = /*#__PURE__*/function () {
  function Marker(viewer, plugin, config) {
    _classCallCheck(this, Marker);
    this.viewer = viewer;
    this.plugin = plugin;
    /** @internal */
    this.state = {
      dynamicSize: false,
      anchor: null,
      visible: false,
      staticTooltip: false,
      position: null,
      position2D: null,
      positions3D: null,
      size: null
    };
    if (!config.id) {
      throw new PSVError("missing marker id");
    }
    this.type = getMarkerType(config);
    this.createElement();
    this.update(config);
  }
  _createClass(Marker, [{
    key: "id",
    get: function get() {
      return this.config.id;
    }
  }, {
    key: "data",
    get: function get() {
      return this.config.data;
    }
  }, {
    key: "domElement",
    get: function get() {
      return null;
    }
  }, {
    key: "threeElement",
    get: function get() {
      return null;
    }
  }, {
    key: "video",
    get: function get() {
      return null;
    }
    /**
     * @internal
     */
  }, {
    key: "destroy",
    value: function destroy() {
      this.hideTooltip();
    }
    /**
     * Checks if it is a 3D marker (imageLayer, videoLayer)
     */
  }, {
    key: "is3d",
    value: function is3d() {
      return false;
    }
    /**
     * Checks if it is a normal marker (image, html, element)
     */
  }, {
    key: "isNormal",
    value: function isNormal() {
      return false;
    }
    /**
     * Checks if it is a polygon/polyline marker
     */
  }, {
    key: "isPoly",
    value: function isPoly() {
      return false;
    }
    /**
     * Checks if it is an SVG marker
     */
  }, {
    key: "isSvg",
    value: function isSvg() {
      return false;
    }
    /**
     * Updates the marker with new properties
     * @throws {@link PSVError} if the configuration is invalid
     * @internal
     */
  }, {
    key: "update",
    value: function update(config) {
      var newType = getMarkerType(config, true);
      if (newType !== void 0 && newType !== this.type) {
        throw new PSVError("cannot change marker type");
      }
      if (utils_exports.isExtendedPosition(config)) {
        utils_exports.logWarn('Use the "position" property to configure the position of a marker');
        config.position = this.viewer.dataHelper.cleanPosition(config);
      }
      if ("width" in config && "height" in config) {
        utils_exports.logWarn('Use the "size" property to configure the size of a marker');
        config.size = {
          width: config["width"],
          height: config["height"]
        };
      }
      this.config = utils_exports.deepmerge(this.config, config);
      if (typeof this.config.tooltip === "string") {
        this.config.tooltip = {
          content: this.config.tooltip
        };
      }
      if (this.config.tooltip && !this.config.tooltip.trigger) {
        this.config.tooltip.trigger = "hover";
      }
      if (utils_exports.isNil(this.config.visible)) {
        this.config.visible = true;
      }
      if (utils_exports.isNil(this.config.zIndex)) {
        this.config.zIndex = 1;
      }
      if (utils_exports.isNil(this.config.opacity)) {
        this.config.opacity = 1;
      }
      this.state.anchor = utils_exports.parsePoint(this.config.anchor);
    }
    /**
     * Returns the markers list content for the marker, it can be either :
     * - the `listContent`
     * - the `tooltip`
     * - the `html`
     * - the `id`
     * @internal
     */
  }, {
    key: "getListContent",
    value: function getListContent() {
      var _this$config$tooltip;
      if (this.config.listContent) {
        return this.config.listContent;
      } else if ((_this$config$tooltip = this.config.tooltip) !== null && _this$config$tooltip !== void 0 && _this$config$tooltip.content) {
        return this.config.tooltip.content;
      } else if (this.config.html) {
        return this.config.html;
      } else {
        return this.id;
      }
    }
    /**
     * Display the tooltip of this marker
     * @internal
     */
  }, {
    key: "showTooltip",
    value: function showTooltip(clientX, clientY) {
      var _this$config$tooltip2;
      if (this.state.visible && (_this$config$tooltip2 = this.config.tooltip) !== null && _this$config$tooltip2 !== void 0 && _this$config$tooltip2.content && this.state.position2D) {
        var config = _objectSpread(_objectSpread({}, this.config.tooltip), {}, {
          style: {
            // prevents conflicts with tooltip tracking
            pointerEvents: this.state.staticTooltip ? "auto" : "none"
          },
          data: this,
          top: 0,
          left: 0
        });
        if (this.isPoly() || this.is3d()) {
          if (clientX || clientY) {
            var viewerPos = utils_exports.getPosition(this.viewer.container);
            config.top = clientY - viewerPos.y;
            config.left = clientX - viewerPos.x;
            config.box = {
              // separate the tooltip from the cursor
              width: 20,
              height: 20
            };
          } else {
            config.top = this.state.position2D.y;
            config.left = this.state.position2D.x;
          }
        } else {
          var position = this.viewer.dataHelper.vector3ToViewerCoords(this.state.positions3D[0]);
          var width = this.state.size.width;
          var height = this.state.size.height;
          if (this.config.hoverScale && !this.state.staticTooltip) {
            width *= this.config.hoverScale.amount;
            height *= this.config.hoverScale.amount;
          }
          config.top = position.y - height * this.state.anchor.y + height / 2;
          config.left = position.x - width * this.state.anchor.x + width / 2;
          config.box = {
            width: width,
            height: height
          };
        }
        if (this.tooltip) {
          this.tooltip.update(this.config.tooltip.content, config);
        } else {
          this.tooltip = this.viewer.createTooltip(config);
        }
      }
    }
    /**
     * Hides the tooltip of this marker
     * @internal
     */
  }, {
    key: "hideTooltip",
    value: function hideTooltip() {
      if (this.tooltip) {
        this.tooltip.hide();
        this.tooltip = null;
      }
    }
  }]);
  return Marker;
}();

// src/markers/AbstractDomMarker.ts
var AbstractDomMarker = /*#__PURE__*/function (_Marker) {
  _inherits(AbstractDomMarker, _Marker);
  var _super15 = _createSuper(AbstractDomMarker);
  function AbstractDomMarker(viewer, plugin, config) {
    _classCallCheck(this, AbstractDomMarker);
    return _super15.call(this, viewer, plugin, config);
  }
  _createClass(AbstractDomMarker, [{
    key: "domElement",
    get: function get() {
      return this.element;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      delete this.element[MARKER_DATA];
      _get(_getPrototypeOf(AbstractDomMarker.prototype), "destroy", this).call(this);
    }
  }, {
    key: "update",
    value: function update(config) {
      _get(_getPrototypeOf(AbstractDomMarker.prototype), "update", this).call(this, config);
      var element = this.domElement;
      element.id = "psv-marker-".concat(this.config.id);
      element.setAttribute("class", "psv-marker");
      if (this.state.visible) {
        element.classList.add("psv-marker--visible");
      }
      if (this.config.tooltip) {
        element.classList.add("psv-marker--has-tooltip");
      }
      if (this.config.content) {
        element.classList.add("psv-marker--has-content");
      }
      if (this.config.className) {
        utils_exports.addClasses(element, this.config.className);
      }
      element.style.opacity = "".concat(this.config.opacity);
      element.style.zIndex = "".concat(30 + this.config.zIndex);
      if (this.config.style) {
        Object.assign(element.style, this.config.style);
      }
    }
  }]);
  return AbstractDomMarker;
}(Marker);

// src/markers/AbstractStandardMarker.ts
var AbstractStandardMarker = /*#__PURE__*/function (_AbstractDomMarker) {
  _inherits(AbstractStandardMarker, _AbstractDomMarker);
  var _super16 = _createSuper(AbstractStandardMarker);
  function AbstractStandardMarker(viewer, plugin, config) {
    _classCallCheck(this, AbstractStandardMarker);
    return _super16.call(this, viewer, plugin, config);
  }
  _createClass(AbstractStandardMarker, [{
    key: "createElement",
    value: function createElement() {
      var _this12 = this;
      this.element[MARKER_DATA] = this;
      this.domElement.addEventListener("transitionend", function () {
        _this12.domElement.style.transition = "";
      });
    }
  }, {
    key: "render",
    value: function render(_ref) {
      var viewerPosition = _ref.viewerPosition,
        zoomLevel = _ref.zoomLevel,
        hoveringMarker = _ref.hoveringMarker;
      this.__updateSize();
      var position = this.viewer.dataHelper.vector3ToViewerCoords(this.state.positions3D[0]);
      position.x -= this.state.size.width * this.state.anchor.x;
      position.y -= this.state.size.height * this.state.anchor.y;
      var isVisible = this.state.positions3D[0].dot(this.viewer.state.direction) > 0 && position.x + this.state.size.width >= 0 && position.x - this.state.size.width <= this.viewer.state.size.width && position.y + this.state.size.height >= 0 && position.y - this.state.size.height <= this.viewer.state.size.height;
      if (isVisible) {
        this.domElement.style.translate = "".concat(position.x, "px ").concat(position.y, "px 0px");
        this.applyScale({
          zoomLevel: zoomLevel,
          viewerPosition: viewerPosition,
          mouseover: this === hoveringMarker
        });
        if (this.type === "element" /* element */) {
          var _this$config$element$, _this$config$element;
          (_this$config$element$ = (_this$config$element = this.config.element).updateMarker) === null || _this$config$element$ === void 0 ? void 0 : _this$config$element$.call(_this$config$element, {
            marker: this,
            position: position,
            viewerPosition: viewerPosition,
            zoomLevel: zoomLevel,
            viewerSize: this.viewer.state.size
          });
        }
        return position;
      } else {
        return null;
      }
    }
  }, {
    key: "update",
    value: function update(config) {
      _get(_getPrototypeOf(AbstractStandardMarker.prototype), "update", this).call(this, config);
      var element = this.domElement;
      element.classList.add("psv-marker--normal");
      if (this.config.scale && Array.isArray(this.config.scale)) {
        this.config.scale = {
          zoom: this.config.scale
        };
      }
      if (typeof this.config.hoverScale === "boolean") {
        this.config.hoverScale = this.config.hoverScale ? this.plugin.config.defaultHoverScale || DEFAULT_HOVER_SCALE : null;
      } else if (typeof this.config.hoverScale === "number") {
        this.config.hoverScale = {
          amount: this.config.hoverScale
        };
      } else if (!this.config.hoverScale) {
        this.config.hoverScale = this.plugin.config.defaultHoverScale;
      }
      if (this.config.hoverScale) {
        this.config.hoverScale = _objectSpread(_objectSpread(_objectSpread({}, DEFAULT_HOVER_SCALE), this.plugin.config.defaultHoverScale), this.config.hoverScale);
      }
    }
    /**
     * Computes the real size of a marker
     * @description This is done by removing all it's transformations (if any) and making it visible
     * before querying its bounding rect
     */
  }, {
    key: "__updateSize",
    value: function __updateSize() {
      if (!this.state.dynamicSize) {
        return;
      }
      var element = this.domElement;
      var init = !this.state.size;
      if (init) {
        element.classList.add("psv-marker--transparent");
      }
      if (this.isSvg()) {
        var rect = element.firstElementChild.getBoundingClientRect();
        this.state.size = {
          width: rect.width,
          height: rect.height
        };
      } else if (this.isNormal()) {
        this.state.size = {
          width: element.offsetWidth,
          height: element.offsetHeight
        };
      }
      if (init) {
        element.classList.remove("psv-marker--transparent");
      }
      if (this.isSvg()) {
        element.style.width = this.state.size.width + "px";
        element.style.height = this.state.size.height + "px";
      }
      if (this.type !== "element" /* element */) {
        this.state.dynamicSize = false;
      }
    }
    /**
     * Computes and applies the scale to the marker
     */
  }, {
    key: "applyScale",
    value: function applyScale(_ref2) {
      var zoomLevel = _ref2.zoomLevel,
        viewerPosition = _ref2.viewerPosition,
        mouseover = _ref2.mouseover;
      if (mouseover !== null && this.config.hoverScale) {
        this.domElement.style.transition = "scale ".concat(this.config.hoverScale.duration, "ms ").concat(this.config.hoverScale.easing);
      }
      var scale = 1;
      if (typeof this.config.scale === "function") {
        scale = this.config.scale(zoomLevel, viewerPosition);
      } else if (this.config.scale) {
        if (Array.isArray(this.config.scale.zoom)) {
          var _this$config$scale$zo = _slicedToArray(this.config.scale.zoom, 2),
            min = _this$config$scale$zo[0],
            max = _this$config$scale$zo[1];
          scale *= min + (max - min) * constants_exports.EASINGS.inQuad(zoomLevel / 100);
        }
        if (Array.isArray(this.config.scale.yaw)) {
          var _this$config$scale$ya = _slicedToArray(this.config.scale.yaw, 2),
            _min = _this$config$scale$ya[0],
            _max = _this$config$scale$ya[1];
          var halfFov = MathUtils.degToRad(this.viewer.state.hFov) / 2;
          var arc = Math.abs(utils_exports.getShortestArc(this.state.position.yaw, viewerPosition.yaw));
          scale *= _max + (_min - _max) * constants_exports.EASINGS.outQuad(Math.max(0, (halfFov - arc) / halfFov));
        }
      }
      if (mouseover && this.config.hoverScale) {
        scale *= this.config.hoverScale.amount;
      }
      this.domElement.style.scale = "".concat(scale);
    }
  }]);
  return AbstractStandardMarker;
}(AbstractDomMarker);
var MarkerNormal = /*#__PURE__*/function (_AbstractStandardMark) {
  _inherits(MarkerNormal, _AbstractStandardMark);
  var _super17 = _createSuper(MarkerNormal);
  function MarkerNormal(viewer, plugin, config) {
    _classCallCheck(this, MarkerNormal);
    return _super17.call(this, viewer, plugin, config);
  }
  _createClass(MarkerNormal, [{
    key: "isNormal",
    value: function isNormal() {
      return true;
    }
  }, {
    key: "createElement",
    value: function createElement() {
      this.element = document.createElement("div");
      _get(_getPrototypeOf(MarkerNormal.prototype), "createElement", this).call(this);
    }
  }, {
    key: "update",
    value: function update(config) {
      _get(_getPrototypeOf(MarkerNormal.prototype), "update", this).call(this, config);
      var element = this.domElement;
      if (!utils_exports.isExtendedPosition(this.config.position)) {
        throw new PSVError("missing marker position");
      }
      if (this.config.image && !this.config.size) {
        throw new PSVError("missing marker size");
      }
      if (this.config.size) {
        this.state.dynamicSize = false;
        this.state.size = this.config.size;
        element.style.width = this.config.size.width + "px";
        element.style.height = this.config.size.height + "px";
      } else {
        this.state.dynamicSize = true;
      }
      switch (this.type) {
        case "image" /* image */:
          this.definition = this.config.image;
          element.style.backgroundImage = "url(\"".concat(this.config.image, "\")");
          break;
        case "html" /* html */:
          this.definition = this.config.html;
          element.innerHTML = this.config.html;
          break;
        case "element" /* element */:
          if (this.definition !== this.config.element) {
            this.definition = this.config.element;
            element.childNodes.forEach(function (n) {
              return n.remove();
            });
            element.appendChild(this.config.element);
            this.config.element.style.display = "block";
          }
          break;
      }
      element.style.transformOrigin = "".concat(this.state.anchor.x * 100, "% ").concat(this.state.anchor.y * 100, "%");
      this.state.position = this.viewer.dataHelper.cleanPosition(this.config.position);
      this.state.positions3D = [this.viewer.dataHelper.sphericalCoordsToVector3(this.state.position)];
    }
  }]);
  return MarkerNormal;
}(AbstractStandardMarker);

// ../shared/shaders/chromaKey.fragment.glsl
var chromaKey_fragment_default = "// https://www.8thwall.com/playground/chromakey-threejs\n\nuniform sampler2D map;\nuniform float alpha;\nuniform bool keying;\nuniform vec3 color;\nuniform float similarity;\nuniform float smoothness;\nuniform float spill;\n\nvarying vec2 vUv;\n\nvec2 RGBtoUV(vec3 rgb) {\n    return vec2(\n        rgb.r * -0.169 + rgb.g * -0.331 + rgb.b *  0.5    + 0.5,\n        rgb.r *  0.5   + rgb.g * -0.419 + rgb.b * -0.081  + 0.5\n    );\n}\n\nvoid main(void) {\n    gl_FragColor = texture2D(map, vUv);\n\n    if (keying) {\n        float chromaDist = distance(RGBtoUV(gl_FragColor.rgb), RGBtoUV(color));\n\n        float baseMask = chromaDist - similarity;\n        float fullMask = pow(clamp(baseMask / smoothness, 0., 1.), 1.5);\n        gl_FragColor.a *= fullMask * alpha;\n\n        float spillVal = pow(clamp(baseMask / spill, 0., 1.), 1.5);\n        float desat = clamp(gl_FragColor.r * 0.2126 + gl_FragColor.g * 0.7152 + gl_FragColor.b * 0.0722, 0., 1.);\n        gl_FragColor.rgb = mix(vec3(desat, desat, desat), gl_FragColor.rgb, spillVal);\n    } else {\n        gl_FragColor.a *= alpha;\n    }\n}\n";

// ../shared/shaders/chromaKey.vertex.glsl
var chromaKey_vertex_default = "varying vec2 vUv;\nuniform vec2 repeat;\nuniform vec2 offset;\n\nvoid main() {\n    vUv = uv * repeat + offset;\n    gl_Position = projectionMatrix *  modelViewMatrix * vec4( position, 1.0 );\n}\n";

// ../shared/ChromaKeyMaterial.ts
var ChromaKeyMaterial = /*#__PURE__*/function (_ShaderMaterial) {
  _inherits(ChromaKeyMaterial, _ShaderMaterial);
  var _super18 = _createSuper(ChromaKeyMaterial);
  function ChromaKeyMaterial(params) {
    var _params$alpha;
    var _this13;
    _classCallCheck(this, ChromaKeyMaterial);
    _this13 = _super18.call(this, {
      transparent: true,
      depthTest: false,
      uniforms: {
        map: {
          value: params === null || params === void 0 ? void 0 : params.map
        },
        repeat: {
          value: new Vector2(1, 1)
        },
        offset: {
          value: new Vector2(0, 0)
        },
        alpha: {
          value: (_params$alpha = params === null || params === void 0 ? void 0 : params.alpha) !== null && _params$alpha !== void 0 ? _params$alpha : 1
        },
        keying: {
          value: false
        },
        color: {
          value: new Color(65280)
        },
        similarity: {
          value: 0.2
        },
        smoothness: {
          value: 0.2
        },
        spill: {
          value: 0.1
        }
      },
      vertexShader: chromaKey_vertex_default,
      fragmentShader: chromaKey_fragment_default
    });
    _this13.chromaKey = params === null || params === void 0 ? void 0 : params.chromaKey;
    return _this13;
  }
  _createClass(ChromaKeyMaterial, [{
    key: "map",
    get: function get() {
      return this.uniforms.map.value;
    },
    set: function set(map) {
      this.uniforms.map.value = map;
    }
  }, {
    key: "alpha",
    set: function set(alpha) {
      this.uniforms.alpha.value = alpha;
    }
  }, {
    key: "offset",
    get: function get() {
      return this.uniforms.offset.value;
    }
  }, {
    key: "repeat",
    get: function get() {
      return this.uniforms.repeat.value;
    }
  }, {
    key: "chromaKey",
    set: function set(chromaKey) {
      this.uniforms.keying.value = (chromaKey === null || chromaKey === void 0 ? void 0 : chromaKey.enabled) === true;
      if (chromaKey !== null && chromaKey !== void 0 && chromaKey.enabled) {
        var _chromaKey$similarity, _chromaKey$smoothness;
        if (_typeof(chromaKey.color) === "object" && "r" in chromaKey.color) {
          this.uniforms.color.value.set(chromaKey.color.r / 255, chromaKey.color.g / 255, chromaKey.color.b / 255);
        } else {
          var _chromaKey$color;
          this.uniforms.color.value.set((_chromaKey$color = chromaKey.color) !== null && _chromaKey$color !== void 0 ? _chromaKey$color : 65280);
        }
        this.uniforms.similarity.value = (_chromaKey$similarity = chromaKey.similarity) !== null && _chromaKey$similarity !== void 0 ? _chromaKey$similarity : 0.2;
        this.uniforms.smoothness.value = (_chromaKey$smoothness = chromaKey.smoothness) !== null && _chromaKey$smoothness !== void 0 ? _chromaKey$smoothness : 0.2;
      }
    }
  }]);
  return ChromaKeyMaterial;
}(ShaderMaterial);

// ../shared/video-utils.ts
function createVideo(_ref3) {
  var src = _ref3.src,
    withCredentials = _ref3.withCredentials,
    muted = _ref3.muted,
    autoplay = _ref3.autoplay;
  var video = document.createElement("video");
  video.crossOrigin = withCredentials ? "use-credentials" : "anonymous";
  video.loop = true;
  video.playsInline = true;
  video.autoplay = autoplay;
  video.muted = muted;
  video.preload = "metadata";
  video.src = src;
  return video;
}
function greatArcIntermediaryPoint(p1, p2, f) {
  var _p = _slicedToArray(p1, 2),
    λ1 = _p[0],
    φ1 = _p[1];
  var _p2 = _slicedToArray(p2, 2),
    λ2 = _p2[0],
    φ2 = _p2[1];
  var r = utils_exports.greatArcDistance(p1, p2);
  var a = Math.sin((1 - f) * r) / Math.sin(r);
  var b = Math.sin(f * r) / Math.sin(r);
  var x = a * Math.cos(φ1) * Math.cos(λ1) + b * Math.cos(φ2) * Math.cos(λ2);
  var y = a * Math.cos(φ1) * Math.sin(λ1) + b * Math.cos(φ2) * Math.sin(λ2);
  var z = a * Math.sin(φ1) + b * Math.sin(φ2);
  return [Math.atan2(y, x), Math.atan2(z, Math.sqrt(x * x + y * y))];
}
function getPolygonCoherentPoints(points) {
  var workPoints = [points[0]];
  var k = 0;
  for (var i = 1; i < points.length; i++) {
    var d = points[i - 1][0] - points[i][0];
    if (d > Math.PI) {
      k += 1;
    } else if (d < -Math.PI) {
      k -= 1;
    }
    workPoints.push([points[i][0] + k * 2 * Math.PI, points[i][1]]);
  }
  return workPoints;
}
function getPolygonCenter(polygon) {
  var points = getPolygonCoherentPoints(polygon);
  var sum = points.reduce(function (intermediary, point) {
    return [intermediary[0] + point[0], intermediary[1] + point[1]];
  });
  return [utils_exports.parseAngle(sum[0] / polygon.length), sum[1] / polygon.length];
}
function getPolylineCenter(polyline) {
  var points = getPolygonCoherentPoints(polyline);
  var length = 0;
  var lengths = [];
  for (var i = 0; i < points.length - 1; i++) {
    var l = utils_exports.greatArcDistance(points[i], points[i + 1]) * constants_exports.SPHERE_RADIUS;
    lengths.push(l);
    length += l;
  }
  var consumed = 0;
  for (var j = 0; j < points.length - 1; j++) {
    if (consumed + lengths[j] > length / 2) {
      var r = (length / 2 - consumed) / lengths[j];
      return greatArcIntermediaryPoint(points[j], points[j + 1], r);
    }
    consumed += lengths[j];
  }
  return points[Math.round(points.length / 2)];
}
var C = new Vector3();
var N = new Vector3();
var V = new Vector3();
var X = new Vector3();
var Y = new Vector3();
var A = new Vector3();
function getGreatCircleIntersection(P1, P2, direction) {
  C.copy(direction).normalize();
  N.crossVectors(P1, P2).normalize();
  V.crossVectors(N, P1).normalize();
  X.copy(P1).multiplyScalar(-C.dot(V));
  Y.copy(V).multiplyScalar(C.dot(P1));
  var H = new Vector3().addVectors(X, Y).normalize();
  A.crossVectors(H, C);
  return H.applyAxisAngle(A, 0.01).multiplyScalar(constants_exports.SPHERE_RADIUS);
}

// src/markers/Marker3D.ts
var Marker3D = /*#__PURE__*/function (_Marker2) {
  _inherits(Marker3D, _Marker2);
  var _super19 = _createSuper(Marker3D);
  function Marker3D(viewer, plugin, config) {
    _classCallCheck(this, Marker3D);
    return _super19.call(this, viewer, plugin, config);
  }
  _createClass(Marker3D, [{
    key: "threeElement",
    get: function get() {
      return this.element;
    }
  }, {
    key: "video",
    get: function get() {
      if (this.type === "videoLayer" /* videoLayer */) {
        return this.threeElement.material.map.image;
      } else {
        return null;
      }
    }
  }, {
    key: "is3d",
    value: function is3d() {
      return true;
    }
  }, {
    key: "createElement",
    value: function createElement() {
      var material = new ChromaKeyMaterial({
        alpha: 0
      });
      var geometry = new PlaneGeometry(1, 1);
      var mesh = new Mesh(geometry, material);
      mesh.userData = _defineProperty({}, MARKER_DATA, this);
      var group = new Group().add(mesh);
      Object.defineProperty(group, "visible", {
        enumerable: true,
        get: function get() {
          return this.children[0].userData[MARKER_DATA].state.visible;
        },
        set: function set(visible) {
          this.children[0].userData[MARKER_DATA].state.visible = visible;
        }
      });
      this.element = mesh;
      if (this.type === "videoLayer" /* videoLayer */) {
        this.viewer.needsContinuousUpdate(true);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      delete this.threeElement.userData[MARKER_DATA];
      if (this.type === "videoLayer" /* videoLayer */) {
        this.video.pause();
        this.viewer.needsContinuousUpdate(false);
      }
      _get(_getPrototypeOf(Marker3D.prototype), "destroy", this).call(this);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.viewer.renderer.isObjectVisible(this.threeElement)) {
        return this.viewer.dataHelper.sphericalCoordsToViewerCoords(this.state.position);
      } else {
        return null;
      }
    }
  }, {
    key: "update",
    value: function update(config) {
      var _this14 = this;
      _get(_getPrototypeOf(Marker3D.prototype), "update", this).call(this, config);
      var mesh = this.threeElement;
      var group = mesh.parent;
      var material = mesh.material;
      this.state.dynamicSize = false;
      if (utils_exports.isExtendedPosition(this.config.position)) {
        if (!this.config.size) {
          throw new PSVError("missing marker size");
        }
        this.state.position = this.viewer.dataHelper.cleanPosition(this.config.position);
        this.state.size = this.config.size;
        mesh.position.set(0.5 - this.state.anchor.x, this.state.anchor.y - 0.5, 0);
        this.viewer.dataHelper.sphericalCoordsToVector3(this.state.position, group.position);
        group.lookAt(0, group.position.y, 0);
        switch (this.config.orientation) {
          case "horizontal":
            group.rotateX(this.state.position.pitch < 0 ? -Math.PI / 2 : Math.PI / 2);
            break;
          case "vertical-left":
            group.rotateY(-Math.PI * 0.4);
            break;
          case "vertical-right":
            group.rotateY(Math.PI * 0.4);
            break;
        }
        group.scale.set(this.config.size.width / 100, this.config.size.height / 100, 1);
        var p = mesh.geometry.getAttribute("position");
        this.state.positions3D = [0, 1, 3, 2].map(function (i) {
          var v3 = new Vector3();
          v3.fromBufferAttribute(p, i);
          return mesh.localToWorld(v3);
        });
      } else {
        var _this$config$position;
        if (((_this$config$position = this.config.position) === null || _this$config$position === void 0 ? void 0 : _this$config$position.length) !== 4) {
          throw new PSVError("missing marker position");
        }
        var positions = this.config.position.map(function (p2) {
          return _this14.viewer.dataHelper.cleanPosition(p2);
        });
        var positions3D = positions.map(function (p2) {
          return _this14.viewer.dataHelper.sphericalCoordsToVector3(p2);
        });
        var centroid = getPolygonCenter(positions.map(function (_ref4) {
          var yaw = _ref4.yaw,
            pitch = _ref4.pitch;
          return [yaw, pitch];
        }));
        this.state.position = {
          yaw: centroid[0],
          pitch: centroid[1]
        };
        this.state.positions3D = positions3D;
        var _p3 = mesh.geometry.getAttribute("position");
        [positions3D[0], positions3D[1], positions3D[3],
        // not a mistake!
        positions3D[2]].forEach(function (v, i) {
          _p3.setX(i, v.x);
          _p3.setY(i, v.y);
          _p3.setZ(i, v.z);
        });
        _p3.needsUpdate = true;
        this.__setTextureWrap(material);
      }
      switch (this.type) {
        case "videoLayer" /* videoLayer */:
          if (this.definition !== this.config.videoLayer) {
            var _material$map;
            (_material$map = material.map) === null || _material$map === void 0 ? void 0 : _material$map.dispose();
            var video = createVideo({
              src: this.config.videoLayer,
              withCredentials: this.viewer.config.withCredentials,
              muted: true,
              autoplay: true
            });
            var texture = new VideoTexture(video);
            material.map = texture;
            material.alpha = 0;
            video.addEventListener("loadedmetadata", function () {
              material.alpha = _this14.config.opacity;
              if (!utils_exports.isExtendedPosition(_this14.config.position)) {
                mesh.material.userData[MARKER_DATA] = {
                  width: video.videoWidth,
                  height: video.videoHeight
                };
                _this14.__setTextureWrap(material);
              }
            }, {
              once: true
            });
            video.play();
            this.definition = this.config.videoLayer;
          }
          break;
        case "imageLayer" /* imageLayer */:
          if (this.definition !== this.config.imageLayer) {
            var _material$map2;
            (_material$map2 = material.map) === null || _material$map2 === void 0 ? void 0 : _material$map2.dispose();
            var _texture = new Texture();
            material.map = _texture;
            material.alpha = 0;
            this.viewer.textureLoader.loadImage(this.config.imageLayer).then(function (image) {
              if (!utils_exports.isExtendedPosition(_this14.config.position)) {
                mesh.material.userData[MARKER_DATA] = {
                  width: image.width,
                  height: image.height
                };
                _this14.__setTextureWrap(material);
              }
              _texture.image = image;
              _texture.anisotropy = 4;
              _texture.needsUpdate = true;
              material.alpha = _this14.config.opacity;
              _this14.viewer.needsUpdate();
            });
            this.definition = this.config.imageLayer;
          }
          break;
      }
      material.chromaKey = this.config.chromaKey;
      mesh.renderOrder = 1e3 + this.config.zIndex;
      mesh.geometry.boundingBox = null;
    }
    /**
     * For layers positionned by corners, applies offset to the texture in order to keep its proportions
     */
  }, {
    key: "__setTextureWrap",
    value: function __setTextureWrap(material) {
      var _this15 = this;
      var imageSize = material.userData[MARKER_DATA];
      if (!imageSize || !imageSize.height || !imageSize.width) {
        material.repeat.set(1, 1);
        material.offset.set(0, 0);
        return;
      }
      var positions = this.config.position.map(function (p) {
        return _this15.viewer.dataHelper.cleanPosition(p);
      });
      var w1 = utils_exports.greatArcDistance([positions[0].yaw, positions[0].pitch], [positions[1].yaw, positions[1].pitch]);
      var w2 = utils_exports.greatArcDistance([positions[3].yaw, positions[3].pitch], [positions[2].yaw, positions[2].pitch]);
      var h1 = utils_exports.greatArcDistance([positions[1].yaw, positions[1].pitch], [positions[2].yaw, positions[2].pitch]);
      var h2 = utils_exports.greatArcDistance([positions[0].yaw, positions[0].pitch], [positions[3].yaw, positions[3].pitch]);
      var layerRatio = (w1 + w2) / (h1 + h2);
      var imageRatio = imageSize.width / imageSize.height;
      var hMargin = 0;
      var vMargin = 0;
      if (layerRatio < imageRatio) {
        hMargin = imageRatio - layerRatio;
      } else {
        vMargin = 1 / imageRatio - 1 / layerRatio;
      }
      material.repeat.set(1 - hMargin, 1 - vMargin);
      material.offset.set(hMargin / 2, vMargin / 2);
    }
  }]);
  return Marker3D;
}(Marker);
var MarkerPolygon = /*#__PURE__*/function (_AbstractDomMarker2) {
  _inherits(MarkerPolygon, _AbstractDomMarker2);
  var _super20 = _createSuper(MarkerPolygon);
  function MarkerPolygon(viewer, plugin, config) {
    _classCallCheck(this, MarkerPolygon);
    return _super20.call(this, viewer, plugin, config);
  }
  _createClass(MarkerPolygon, [{
    key: "createElement",
    value: function createElement() {
      this.element = document.createElementNS(SVG_NS, this.isPolygon ? "polygon" : "polyline");
      this.element[MARKER_DATA] = this;
    }
  }, {
    key: "isPoly",
    value: function isPoly() {
      return true;
    }
    /**
     * Checks if it is a polygon/polyline using pixel coordinates
     */
  }, {
    key: "isPixels",
    get: function get() {
      return this.type === "polygonPixels" /* polygonPixels */ || this.type === "polylinePixels" /* polylinePixels */;
    }
    /**
     * Checks if it is a polygon marker
     */
  }, {
    key: "isPolygon",
    get: function get() {
      return this.type === "polygon" /* polygon */ || this.type === "polygonPixels" /* polygonPixels */;
    }
    /**
     * Checks if it is a polyline marker
     */
  }, {
    key: "isPolyline",
    get: function get() {
      return this.type === "polyline" /* polyline */ || this.type === "polylinePixels" /* polylinePixels */;
    }
  }, {
    key: "render",
    value: function render() {
      var positions = this.__getPolyPositions();
      var isVisible = positions.length > (this.isPolygon ? 2 : 1);
      if (isVisible) {
        var position = this.viewer.dataHelper.sphericalCoordsToViewerCoords(this.state.position);
        var points = positions.map(function (pos) {
          return pos.x - position.x + "," + (pos.y - position.y);
        }).join(" ");
        this.domElement.setAttributeNS(null, "points", points);
        this.domElement.setAttributeNS(null, "transform", "translate(".concat(position.x, " ").concat(position.y, ")"));
        return position;
      } else {
        return null;
      }
    }
  }, {
    key: "update",
    value: function update(config) {
      var _this16 = this;
      _get(_getPrototypeOf(MarkerPolygon.prototype), "update", this).call(this, config);
      var element = this.domElement;
      element.classList.add("psv-marker--poly");
      this.state.dynamicSize = true;
      if (this.config.svgStyle) {
        Object.entries(this.config.svgStyle).forEach(function (_ref5) {
          var _ref6 = _slicedToArray(_ref5, 2),
            prop = _ref6[0],
            value = _ref6[1];
          element.setAttributeNS(null, utils_exports.dasherize(prop), value);
        });
        if (this.isPolyline && !this.config.svgStyle.fill) {
          element.setAttributeNS(null, "fill", "none");
        }
      } else if (this.isPolygon) {
        element.setAttributeNS(null, "fill", "rgba(0,0,0,0.5)");
      } else if (this.isPolyline) {
        element.setAttributeNS(null, "fill", "none");
        element.setAttributeNS(null, "stroke", "rgb(0,0,0)");
      }
      var actualPoly = this.config[this.type];
      if (!Array.isArray(actualPoly[0])) {
        for (var i = 0; i < actualPoly.length; i++) {
          actualPoly.splice(i, 2, [actualPoly[i], actualPoly[i + 1]]);
        }
      }
      if (this.isPixels) {
        this.definition = actualPoly.map(function (coord) {
          var sphericalCoords = _this16.viewer.dataHelper.textureCoordsToSphericalCoords({
            textureX: coord[0],
            textureY: coord[1]
          });
          return [sphericalCoords.yaw, sphericalCoords.pitch];
        });
      } else {
        this.definition = actualPoly.map(function (coord) {
          return [utils_exports.parseAngle(coord[0]), utils_exports.parseAngle(coord[1], true)];
        });
      }
      var centroid = this.isPolygon ? getPolygonCenter(this.definition) : getPolylineCenter(this.definition);
      this.state.position = {
        yaw: centroid[0],
        pitch: centroid[1]
      };
      this.state.positions3D = this.definition.map(function (coord) {
        return _this16.viewer.dataHelper.sphericalCoordsToVector3({
          yaw: coord[0],
          pitch: coord[1]
        });
      });
    }
    /**
     * Computes viewer coordinates of each point of a polygon/polyline<br>
     * It handles points behind the camera by creating intermediary points suitable for the projector
     */
  }, {
    key: "__getPolyPositions",
    value: function __getPolyPositions() {
      var _this17 = this;
      var nbVectors = this.state.positions3D.length;
      var positions3D = this.state.positions3D.map(function (vector) {
        return {
          vector: vector,
          visible: vector.dot(_this17.viewer.state.direction) > 0
        };
      });
      var toBeComputed = [];
      positions3D.forEach(function (pos, i) {
        if (!pos.visible) {
          var neighbours = [i === 0 ? positions3D[nbVectors - 1] : positions3D[i - 1], i === nbVectors - 1 ? positions3D[0] : positions3D[i + 1]];
          neighbours.forEach(function (neighbour) {
            if (neighbour.visible) {
              toBeComputed.push({
                visible: neighbour.vector,
                invisible: pos.vector,
                index: i
              });
            }
          });
        }
      });
      toBeComputed.reverse().forEach(function (pair) {
        positions3D.splice(pair.index, 0, {
          vector: getGreatCircleIntersection(pair.visible, pair.invisible, _this17.viewer.state.direction),
          visible: true
        });
      });
      return positions3D.filter(function (pos) {
        return pos.visible;
      }).map(function (pos) {
        return _this17.viewer.dataHelper.vector3ToViewerCoords(pos.vector);
      });
    }
  }]);
  return MarkerPolygon;
}(AbstractDomMarker);
var MarkerSvg = /*#__PURE__*/function (_AbstractStandardMark2) {
  _inherits(MarkerSvg, _AbstractStandardMark2);
  var _super21 = _createSuper(MarkerSvg);
  function MarkerSvg(viewer, plugin, config) {
    _classCallCheck(this, MarkerSvg);
    return _super21.call(this, viewer, plugin, config);
  }
  _createClass(MarkerSvg, [{
    key: "isSvg",
    value: function isSvg() {
      return true;
    }
  }, {
    key: "createElement",
    value: function createElement() {
      var svgType = this.type === "square" /* square */ ? "rect" : this.type;
      var elt = document.createElementNS(SVG_NS, svgType);
      this.element = document.createElementNS(SVG_NS, "svg");
      this.element.appendChild(elt);
      _get(_getPrototypeOf(MarkerSvg.prototype), "createElement", this).call(this);
    }
  }, {
    key: "update",
    value: function update(config) {
      _get(_getPrototypeOf(MarkerSvg.prototype), "update", this).call(this, config);
      var svgElement = this.domElement.firstElementChild;
      if (!utils_exports.isExtendedPosition(this.config.position)) {
        throw new PSVError("missing marker position");
      }
      this.state.dynamicSize = true;
      switch (this.type) {
        case "square" /* square */:
          this.definition = {
            x: 0,
            y: 0,
            width: this.config.square,
            height: this.config.square
          };
          break;
        case "rect" /* rect */:
          if (Array.isArray(this.config.rect)) {
            this.definition = {
              x: 0,
              y: 0,
              width: this.config.rect[0],
              height: this.config.rect[1]
            };
          } else {
            this.definition = {
              x: 0,
              y: 0,
              width: this.config.rect.width,
              height: this.config.rect.height
            };
          }
          break;
        case "circle" /* circle */:
          this.definition = {
            cx: this.config.circle,
            cy: this.config.circle,
            r: this.config.circle
          };
          break;
        case "ellipse" /* ellipse */:
          if (Array.isArray(this.config.ellipse)) {
            this.definition = {
              cx: this.config.ellipse[0],
              cy: this.config.ellipse[1],
              rx: this.config.ellipse[0],
              ry: this.config.ellipse[1]
            };
          } else {
            this.definition = {
              cx: this.config.ellipse.rx,
              cy: this.config.ellipse.ry,
              rx: this.config.ellipse.rx,
              ry: this.config.ellipse.ry
            };
          }
          break;
        case "path" /* path */:
          this.definition = {
            d: this.config.path
          };
          break;
      }
      Object.entries(this.definition).forEach(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
          prop = _ref8[0],
          value = _ref8[1];
        svgElement.setAttributeNS(null, prop, value);
      });
      if (this.config.svgStyle) {
        Object.entries(this.config.svgStyle).forEach(function (_ref9) {
          var _ref10 = _slicedToArray(_ref9, 2),
            prop = _ref10[0],
            value = _ref10[1];
          svgElement.setAttributeNS(null, utils_exports.dasherize(prop), value);
        });
      } else {
        svgElement.setAttributeNS(null, "fill", "rgba(0,0,0,0.5)");
      }
      this.domElement.style.transformOrigin = "".concat(this.state.anchor.x * 100, "% ").concat(this.state.anchor.y * 100, "%");
      this.state.position = this.viewer.dataHelper.cleanPosition(this.config.position);
      this.state.positions3D = [this.viewer.dataHelper.sphericalCoordsToVector3(this.state.position)];
    }
  }]);
  return MarkerSvg;
}(AbstractStandardMarker);

// src/MarkersPlugin.ts
var getConfig = utils_exports.getConfigParser({
  clickEventOnMarker: false,
  gotoMarkerSpeed: "8rpm",
  markers: null,
  defaultHoverScale: null
}, {
  defaultHoverScale: function defaultHoverScale(_defaultHoverScale) {
    if (!_defaultHoverScale) {
      return null;
    }
    if (_defaultHoverScale === true) {
      _defaultHoverScale = DEFAULT_HOVER_SCALE;
    }
    if (typeof _defaultHoverScale === "number") {
      _defaultHoverScale = {
        amount: _defaultHoverScale
      };
    }
    return _objectSpread(_objectSpread({}, DEFAULT_HOVER_SCALE), _defaultHoverScale);
  }
});
function getMarkerCtor(config) {
  var type = getMarkerType(config, false);
  switch (type) {
    case "image":
    case "html":
    case "element":
      return MarkerNormal;
    case "imageLayer":
    case "videoLayer":
      return Marker3D;
    case "polygon":
    case "polyline":
    case "polygonPixels":
    case "polylinePixels":
      return MarkerPolygon;
    case "square":
    case "rect":
    case "circle":
    case "ellipse":
    case "path":
      return MarkerSvg;
    default:
      throw new PSVError("invalid marker type");
  }
}
var MarkersPlugin = /*#__PURE__*/function (_AbstractConfigurable) {
  _inherits(MarkersPlugin, _AbstractConfigurable);
  var _super22 = _createSuper(MarkersPlugin);
  function MarkersPlugin(viewer, config) {
    var _this18;
    _classCallCheck(this, MarkersPlugin);
    _this18 = _super22.call(this, viewer, config);
    _this18.markers = {};
    _this18.state = {
      visible: true,
      showAllTooltips: false,
      currentMarker: null,
      hoveringMarker: null,
      // require a 2nd render (only the scene) when 3d markers visibility changes
      needsReRender: false
    };
    _this18.container = document.createElement("div");
    _this18.container.className = "psv-markers";
    _this18.viewer.container.appendChild(_this18.container);
    _this18.svgContainer = document.createElementNS(SVG_NS, "svg");
    _this18.svgContainer.setAttribute("class", "psv-markers-svg-container");
    _this18.container.appendChild(_this18.svgContainer);
    _this18.container.addEventListener("mouseenter", _assertThisInitialized(_this18), true);
    _this18.container.addEventListener("mouseleave", _assertThisInitialized(_this18), true);
    _this18.container.addEventListener("mousemove", _assertThisInitialized(_this18), true);
    _this18.container.addEventListener("contextmenu", _assertThisInitialized(_this18));
    return _this18;
  }
  /**
   * @internal
   */
  _createClass(MarkersPlugin, [{
    key: "init",
    value: function init() {
      _get(_getPrototypeOf(MarkersPlugin.prototype), "init", this).call(this);
      utils_exports.checkStylesheet(this.viewer.container, "markers-plugin");
      this.viewer.addEventListener(events_exports$1.ClickEvent.type, this);
      this.viewer.addEventListener(events_exports$1.DoubleClickEvent.type, this);
      this.viewer.addEventListener(events_exports$1.RenderEvent.type, this);
      this.viewer.addEventListener(events_exports$1.ConfigChangedEvent.type, this);
      this.viewer.addEventListener(events_exports$1.ObjectEnterEvent.type, this);
      this.viewer.addEventListener(events_exports$1.ObjectHoverEvent.type, this);
      this.viewer.addEventListener(events_exports$1.ObjectLeaveEvent.type, this);
      this.viewer.addEventListener(events_exports$1.ReadyEvent.type, this, {
        once: true
      });
    }
    /**
     * @internal
     */
  }, {
    key: "destroy",
    value: function destroy() {
      this.clearMarkers(false);
      this.viewer.unobserveObjects(MARKER_DATA);
      this.viewer.removeEventListener(events_exports$1.ClickEvent.type, this);
      this.viewer.removeEventListener(events_exports$1.DoubleClickEvent.type, this);
      this.viewer.removeEventListener(events_exports$1.RenderEvent.type, this);
      this.viewer.removeEventListener(events_exports$1.ObjectEnterEvent.type, this);
      this.viewer.removeEventListener(events_exports$1.ObjectHoverEvent.type, this);
      this.viewer.removeEventListener(events_exports$1.ObjectLeaveEvent.type, this);
      this.viewer.removeEventListener(events_exports$1.ReadyEvent.type, this);
      this.viewer.container.removeChild(this.container);
      _get(_getPrototypeOf(MarkersPlugin.prototype), "destroy", this).call(this);
    }
    /**
     * @internal
     */
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      var _marker$config$style;
      switch (e.type) {
        case events_exports$1.ReadyEvent.type:
          if (this.config.markers) {
            this.setMarkers(this.config.markers);
            delete this.config.markers;
          }
          break;
        case events_exports$1.RenderEvent.type:
          this.renderMarkers();
          break;
        case events_exports$1.ClickEvent.type:
          this.__onClick(e, false);
          break;
        case events_exports$1.DoubleClickEvent.type:
          this.__onClick(e, true);
          break;
        case events_exports$1.ObjectEnterEvent.type:
        case events_exports$1.ObjectLeaveEvent.type:
        case events_exports$1.ObjectHoverEvent.type:
          if (e.userDataKey === MARKER_DATA) {
            var event = e.originalEvent;
            var marker = e.object.userData[MARKER_DATA];
            switch (e.type) {
              case events_exports$1.ObjectEnterEvent.type:
                if ((_marker$config$style = marker.config.style) !== null && _marker$config$style !== void 0 && _marker$config$style.cursor) {
                  this.viewer.setCursor(marker.config.style.cursor);
                } else if (marker.config.tooltip || marker.config.content) {
                  this.viewer.setCursor("pointer");
                }
                this.__onEnterMarker(event, marker);
                break;
              case events_exports$1.ObjectLeaveEvent.type:
                this.viewer.setCursor(null);
                this.__onLeaveMarker(marker);
                break;
              case events_exports$1.ObjectHoverEvent.type:
                this.__onHoverMarker(event, marker);
                break;
            }
          }
          break;
        case "mouseenter":
          this.__onEnterMarker(e, this.__getTargetMarker(e.target));
          break;
        case "mouseleave":
          this.__onLeaveMarker(this.__getTargetMarker(e.target));
          break;
        case "mousemove":
          this.__onHoverMarker(e, this.__getTargetMarker(e.target, true));
          break;
        case "contextmenu":
          e.preventDefault();
          break;
      }
    }
    /**
     * Toggles all markers
     */
  }, {
    key: "toggleAllMarkers",
    value: function toggleAllMarkers() {
      if (this.state.visible) {
        this.hideAllMarkers();
      } else {
        this.showAllMarkers();
      }
    }
    /**
     * Shows all markers
     */
  }, {
    key: "showAllMarkers",
    value: function showAllMarkers() {
      this.state.visible = true;
      this.renderMarkers();
      this.dispatchEvent(new _ShowMarkersEvent2());
    }
    /**
     * Hides all markers
     */
  }, {
    key: "hideAllMarkers",
    value: function hideAllMarkers() {
      this.state.visible = false;
      this.renderMarkers();
      this.dispatchEvent(new _HideMarkersEvent2());
    }
    /**
     * Toggles the visibility of all tooltips
     */
  }, {
    key: "toggleAllTooltips",
    value: function toggleAllTooltips() {
      if (this.state.showAllTooltips) {
        this.hideAllTooltips();
      } else {
        this.showAllTooltips();
      }
    }
    /**
     *  Displays all tooltips
     */
  }, {
    key: "showAllTooltips",
    value: function showAllTooltips() {
      this.state.showAllTooltips = true;
      Object.values(this.markers).forEach(function (marker) {
        marker.state.staticTooltip = true;
        marker.showTooltip();
      });
    }
    /**
     * Hides all tooltips
     */
  }, {
    key: "hideAllTooltips",
    value: function hideAllTooltips() {
      this.state.showAllTooltips = false;
      Object.values(this.markers).forEach(function (marker) {
        marker.state.staticTooltip = false;
        marker.hideTooltip();
      });
    }
    /**
     * Returns the total number of markers
     */
  }, {
    key: "getNbMarkers",
    value: function getNbMarkers() {
      return Object.keys(this.markers).length;
    }
    /**
     * Returns all the markers
     */
  }, {
    key: "getMarkers",
    value: function getMarkers() {
      return Object.values(this.markers);
    }
    /**
     * Adds a new marker to viewer
     * @throws {@link PSVError} when the marker's id is missing or already exists
     */
  }, {
    key: "addMarker",
    value: function addMarker(config) {
      var render = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (this.markers[config.id]) {
        throw new PSVError("marker \"".concat(config.id, "\" already exists"));
      }
      var marker = new (getMarkerCtor(config))(this.viewer, this, config);
      if (marker.isPoly()) {
        this.svgContainer.appendChild(marker.domElement);
      } else if (marker.is3d()) {
        this.viewer.renderer.addObject(marker.threeElement.parent);
      } else {
        this.container.appendChild(marker.domElement);
      }
      this.markers[marker.id] = marker;
      if (this.state.showAllTooltips) {
        marker.state.staticTooltip = true;
      }
      if (render) {
        this.__afterChangerMarkers();
      }
    }
    /**
     * Returns the internal marker object for a marker id
     * @throws {@link PSVError} when the marker cannot be found
     */
  }, {
    key: "getMarker",
    value: function getMarker(markerId) {
      var id = _typeof(markerId) === "object" ? markerId.id : markerId;
      if (!this.markers[id]) {
        throw new PSVError("cannot find marker \"".concat(id, "\""));
      }
      return this.markers[id];
    }
    /**
     * Returns the last marker selected by the user
     */
  }, {
    key: "getCurrentMarker",
    value: function getCurrentMarker() {
      return this.state.currentMarker;
    }
    /**
     * Updates the existing marker with the same id
     * @description Every property can be changed but you can't change its type (Eg: `image` to `html`)
     */
  }, {
    key: "updateMarker",
    value: function updateMarker(config) {
      var render = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var marker = this.getMarker(config.id);
      marker.update(config);
      if (render) {
        var _marker$config$toolti;
        this.__afterChangerMarkers();
        if (marker === this.state.hoveringMarker && ((_marker$config$toolti = marker.config.tooltip) === null || _marker$config$toolti === void 0 ? void 0 : _marker$config$toolti.trigger) === "hover" || marker.state.staticTooltip) {
          marker.showTooltip();
        }
      }
    }
    /**
     * Removes a marker from the viewer
     */
  }, {
    key: "removeMarker",
    value: function removeMarker(markerId) {
      var render = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var marker = this.getMarker(markerId);
      if (marker.isPoly()) {
        this.svgContainer.removeChild(marker.domElement);
      } else if (marker.is3d()) {
        this.viewer.renderer.removeObject(marker.threeElement.parent);
      } else {
        this.container.removeChild(marker.domElement);
      }
      if (this.state.hoveringMarker === marker) {
        this.state.hoveringMarker = null;
      }
      if (this.state.currentMarker === marker) {
        this.state.currentMarker = null;
      }
      marker.destroy();
      delete this.markers[marker.id];
      if (render) {
        this.__afterChangerMarkers();
      }
    }
    /**
     * Removes multiple markers
     */
  }, {
    key: "removeMarkers",
    value: function removeMarkers(markerIds) {
      var _this19 = this;
      var render = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      markerIds.forEach(function (markerId) {
        return _this19.removeMarker(markerId, false);
      });
      if (render) {
        this.__afterChangerMarkers();
      }
    }
    /**
     * Replaces all markers
     */
  }, {
    key: "setMarkers",
    value: function setMarkers(markers) {
      var _this20 = this;
      var render = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.clearMarkers(false);
      markers === null || markers === void 0 ? void 0 : markers.forEach(function (marker) {
        _this20.addMarker(marker, false);
      });
      if (render) {
        this.__afterChangerMarkers();
      }
    }
    /**
     * Removes all markers
     */
  }, {
    key: "clearMarkers",
    value: function clearMarkers() {
      var _this21 = this;
      var render = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      Object.keys(this.markers).forEach(function (markerId) {
        _this21.removeMarker(markerId, false);
      });
      if (render) {
        this.__afterChangerMarkers();
      }
    }
    /**
     * Rotate the view to face the marker
     */
  }, {
    key: "gotoMarker",
    value: function gotoMarker(markerId) {
      var _this22 = this;
      var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.config.gotoMarkerSpeed;
      var marker = this.getMarker(markerId);
      if (!speed) {
        this.viewer.rotate(marker.state.position);
        if (!utils_exports.isNil(marker.config.zoomLvl)) {
          this.viewer.zoom(marker.config.zoomLvl);
        }
        this.dispatchEvent(new _GotoMarkerDoneEvent2(marker));
        return Promise.resolve();
      } else {
        return this.viewer.animate(_objectSpread(_objectSpread({}, marker.state.position), {}, {
          zoom: marker.config.zoomLvl,
          speed: speed
        })).then(function () {
          _this22.dispatchEvent(new _GotoMarkerDoneEvent2(marker));
        });
      }
    }
    /**
     * Hides a marker
     */
  }, {
    key: "hideMarker",
    value: function hideMarker(markerId) {
      this.toggleMarker(markerId, false);
    }
    /**
     * Shows a marker
     */
  }, {
    key: "showMarker",
    value: function showMarker(markerId) {
      this.toggleMarker(markerId, true);
    }
    /**
     * Forces the display of the tooltip of a marker
     */
  }, {
    key: "showMarkerTooltip",
    value: function showMarkerTooltip(markerId) {
      var marker = this.getMarker(markerId);
      marker.state.staticTooltip = true;
      marker.showTooltip();
    }
    /**
     * Hides the tooltip of a marker
     */
  }, {
    key: "hideMarkerTooltip",
    value: function hideMarkerTooltip(markerId) {
      var marker = this.getMarker(markerId);
      marker.state.staticTooltip = false;
      marker.hideTooltip();
    }
    /**
     * Toggles a marker visibility
     */
  }, {
    key: "toggleMarker",
    value: function toggleMarker(markerId, visible) {
      var marker = this.getMarker(markerId);
      marker.config.visible = utils_exports.isNil(visible) ? !marker.config.visible : visible;
      this.renderMarkers();
    }
    /**
     * Opens the panel with the content of the marker
     */
  }, {
    key: "showMarkerPanel",
    value: function showMarkerPanel(markerId) {
      var marker = this.getMarker(markerId);
      if (marker.config.content) {
        this.viewer.panel.show({
          id: ID_PANEL_MARKER,
          content: marker.config.content
        });
      } else {
        this.hideMarkerPanel();
      }
    }
    /**
     * Closes the panel if currently showing the content of a marker
     */
  }, {
    key: "hideMarkerPanel",
    value: function hideMarkerPanel() {
      this.viewer.panel.hide(ID_PANEL_MARKER);
    }
    /**
     * Toggles the visibility of the list of markers
     */
  }, {
    key: "toggleMarkersList",
    value: function toggleMarkersList() {
      if (this.viewer.panel.isVisible(ID_PANEL_MARKERS_LIST)) {
        this.hideMarkersList();
      } else {
        this.showMarkersList();
      }
    }
    /**
     * Opens side panel with the list of markers
     */
  }, {
    key: "showMarkersList",
    value: function showMarkersList() {
      var _this23 = this;
      var markers = [];
      if (this.state.visible) {
        Object.values(this.markers).forEach(function (marker) {
          if (marker.config.visible && !marker.config.hideList) {
            markers.push(marker);
          }
        });
      }
      var e = new _RenderMarkersListEvent2(markers);
      this.dispatchEvent(e);
      markers = e.markers;
      this.viewer.panel.show({
        id: ID_PANEL_MARKERS_LIST,
        content: MARKERS_LIST_TEMPLATE(markers, this.viewer.config.lang[MarkersButton.id]),
        noMargin: true,
        clickHandler: function clickHandler(target) {
          var li = utils_exports.getClosest(target, "li");
          var markerId = li ? li.dataset[MARKER_DATA] : void 0;
          if (markerId) {
            var marker = _this23.getMarker(markerId);
            _this23.dispatchEvent(new _SelectMarkerListEvent2(marker));
            _this23.gotoMarker(marker.id);
            _this23.hideMarkersList();
          }
        }
      });
    }
    /**
     * Closes side panel if it contains the list of markers
     */
  }, {
    key: "hideMarkersList",
    value: function hideMarkersList() {
      this.viewer.panel.hide(ID_PANEL_MARKERS_LIST);
    }
    /**
     * Updates the visibility and the position of all markers
     */
  }, {
    key: "renderMarkers",
    value: function renderMarkers() {
      var _this24 = this;
      if (this.state.needsReRender) {
        this.state.needsReRender = false;
        return;
      }
      var zoomLevel = this.viewer.getZoomLevel();
      var viewerPosition = this.viewer.getPosition();
      var hoveringMarker = this.state.hoveringMarker;
      Object.values(this.markers).forEach(function (marker) {
        var isVisible = _this24.state.visible && marker.config.visible;
        var visibilityChanged = false;
        var position = null;
        if (isVisible) {
          position = marker.render({
            viewerPosition: viewerPosition,
            zoomLevel: zoomLevel,
            hoveringMarker: hoveringMarker
          });
          isVisible = !!position;
        }
        visibilityChanged = marker.state.visible !== isVisible;
        marker.state.visible = isVisible;
        marker.state.position2D = position;
        if (!marker.is3d()) {
          utils_exports.toggleClass(marker.domElement, "psv-marker--visible", isVisible);
        }
        if (!isVisible) {
          marker.hideTooltip();
        } else if (marker.state.staticTooltip) {
          marker.showTooltip();
        } else if (marker !== _this24.state.hoveringMarker) {
          marker.hideTooltip();
        }
        if (visibilityChanged) {
          _this24.dispatchEvent(new _MarkerVisibilityEvent2(marker, isVisible));
          if (marker.is3d()) {
            _this24.state.needsReRender = true;
          }
        }
      });
      if (this.state.needsReRender) {
        this.viewer.needsUpdate();
      }
    }
  }, {
    key: "__getTargetMarker",
    value: function __getTargetMarker(target) {
      var closest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (target instanceof Node) {
        var target2 = closest ? utils_exports.getClosest(target, ".psv-marker") : target;
        return target2 ? target2[MARKER_DATA] : void 0;
      } else if (Array.isArray(target)) {
        return target.map(function (o) {
          return o.userData[MARKER_DATA];
        }).filter(function (m) {
          return !!m;
        }).sort(function (a, b) {
          return b.config.zIndex - a.config.zIndex;
        })[0];
      } else {
        return null;
      }
    }
    /**
     * Handles mouse enter events, show the tooltip for non polygon markers
     */
  }, {
    key: "__onEnterMarker",
    value: function __onEnterMarker(e, marker) {
      if (marker) {
        var _marker$config$toolti2;
        this.state.hoveringMarker = marker;
        this.dispatchEvent(new _EnterMarkerEvent2(marker));
        if (marker instanceof AbstractStandardMarker) {
          marker.applyScale({
            zoomLevel: this.viewer.getZoomLevel(),
            viewerPosition: this.viewer.getPosition(),
            mouseover: true
          });
        }
        if (!marker.state.staticTooltip && ((_marker$config$toolti2 = marker.config.tooltip) === null || _marker$config$toolti2 === void 0 ? void 0 : _marker$config$toolti2.trigger) === "hover") {
          marker.showTooltip(e.clientX, e.clientY);
        }
      }
    }
    /**
     * Handles mouse leave events, hide the tooltip
     */
  }, {
    key: "__onLeaveMarker",
    value: function __onLeaveMarker(marker) {
      if (marker) {
        var _marker$config$toolti3;
        this.dispatchEvent(new _LeaveMarkerEvent2(marker));
        if (marker instanceof AbstractStandardMarker) {
          marker.applyScale({
            zoomLevel: this.viewer.getZoomLevel(),
            viewerPosition: this.viewer.getPosition(),
            mouseover: false
          });
        }
        this.state.hoveringMarker = null;
        if (!marker.state.staticTooltip && ((_marker$config$toolti3 = marker.config.tooltip) === null || _marker$config$toolti3 === void 0 ? void 0 : _marker$config$toolti3.trigger) === "hover") {
          marker.hideTooltip();
        } else if (marker.state.staticTooltip) {
          marker.showTooltip();
        }
      }
    }
    /**
     * Handles mouse move events, refresh the tooltip for polygon markers
     */
  }, {
    key: "__onHoverMarker",
    value: function __onHoverMarker(e, marker) {
      if (marker && (marker.isPoly() || marker.is3d())) {
        var _marker$config$toolti4;
        if (((_marker$config$toolti4 = marker.config.tooltip) === null || _marker$config$toolti4 === void 0 ? void 0 : _marker$config$toolti4.trigger) === "hover") {
          marker.showTooltip(e.clientX, e.clientY);
        }
      }
    }
    /**
     * Handles mouse click events, select the marker and open the panel if necessary
     */
  }, {
    key: "__onClick",
    value: function __onClick(e, dblclick) {
      var threeMarker = this.__getTargetMarker(e.data.objects);
      var stdMarker = this.__getTargetMarker(e.data.target, true);
      var marker = stdMarker || threeMarker;
      if (this.state.currentMarker && this.state.currentMarker !== marker) {
        var _this$state$currentMa;
        this.dispatchEvent(new _UnselectMarkerEvent2(this.state.currentMarker));
        this.viewer.panel.hide(ID_PANEL_MARKER);
        if (!this.state.showAllTooltips && ((_this$state$currentMa = this.state.currentMarker.config.tooltip) === null || _this$state$currentMa === void 0 ? void 0 : _this$state$currentMa.trigger) === "click") {
          this.hideMarkerTooltip(this.state.currentMarker.id);
        }
        this.state.currentMarker = null;
      }
      if (marker) {
        this.state.currentMarker = marker;
        this.dispatchEvent(new _SelectMarkerEvent2(marker, dblclick, e.data.rightclick));
        if (this.config.clickEventOnMarker) {
          e.data.marker = marker;
        } else {
          e.stopImmediatePropagation();
        }
        if (this.markers[marker.id]) {
          var _marker$config$toolti5;
          if (((_marker$config$toolti5 = marker.config.tooltip) === null || _marker$config$toolti5 === void 0 ? void 0 : _marker$config$toolti5.trigger) === "click") {
            if (marker.tooltip) {
              this.hideMarkerTooltip(marker.id);
            } else {
              this.showMarkerTooltip(marker.id);
            }
          } else {
            this.showMarkerPanel(marker.id);
          }
        }
      }
    }
  }, {
    key: "__afterChangerMarkers",
    value: function __afterChangerMarkers() {
      this.__refreshUi();
      this.__checkObjectsObserver();
      this.viewer.needsUpdate();
      this.dispatchEvent(new _SetMarkersEvent2(this.getMarkers()));
    }
    /**
     * Updates the visiblity of the panel and the buttons
     */
  }, {
    key: "__refreshUi",
    value: function __refreshUi() {
      var _this$viewer$navbar$g, _this$viewer$navbar$g2;
      var nbMarkers = Object.values(this.markers).filter(function (m) {
        return !m.config.hideList;
      }).length;
      if (nbMarkers === 0) {
        if (this.viewer.panel.isVisible(ID_PANEL_MARKERS_LIST) || this.viewer.panel.isVisible(ID_PANEL_MARKER)) {
          this.viewer.panel.hide();
        }
      } else {
        if (this.viewer.panel.isVisible(ID_PANEL_MARKERS_LIST)) {
          this.showMarkersList();
        } else if (this.viewer.panel.isVisible(ID_PANEL_MARKER)) {
          this.state.currentMarker ? this.showMarkerPanel(this.state.currentMarker.id) : this.viewer.panel.hide();
        }
      }
      (_this$viewer$navbar$g = this.viewer.navbar.getButton(MarkersButton.id, false)) === null || _this$viewer$navbar$g === void 0 ? void 0 : _this$viewer$navbar$g.toggle(nbMarkers > 0);
      (_this$viewer$navbar$g2 = this.viewer.navbar.getButton(MarkersListButton.id, false)) === null || _this$viewer$navbar$g2 === void 0 ? void 0 : _this$viewer$navbar$g2.toggle(nbMarkers > 0);
    }
    /**
     * Adds or remove the objects observer if there are 3D markers
     */
  }, {
    key: "__checkObjectsObserver",
    value: function __checkObjectsObserver() {
      var has3d = Object.values(this.markers).some(function (marker) {
        return marker.is3d();
      });
      if (has3d) {
        this.viewer.observeObjects(MARKER_DATA);
      } else {
        this.viewer.unobserveObjects(MARKER_DATA);
      }
    }
  }]);
  return MarkersPlugin;
}(AbstractConfigurablePlugin);
MarkersPlugin.id = "markers";
MarkersPlugin.VERSION = "5.6.0";
MarkersPlugin.configParser = getConfig;
MarkersPlugin.readonlyOptions = ["markers"];

// src/index.ts
DEFAULTS.lang[MarkersButton.id] = "Markers";
DEFAULTS.lang[MarkersListButton.id] = "Markers list";
registerButton(MarkersButton, "caption:left");
registerButton(MarkersListButton, "caption:left");
export { MarkersPlugin, events_exports as events };
//# sourceMappingURL=index.module.js.map
